import React, {Component} from "react";

export class FunContainer extends Component {
    render() {
        return (
            <div>
                <Fun/>
            </div>
        )
    }
}

class Fun extends Component {
    render() {
        return (
            <div>
                <h1>
                    Fun Stuff TBA
                </h1>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/MainPages/Fun.js